import React from 'react';
import SearchForm from './SearchForm';

const Employees = () => {
  return (
    <div className="Employees">
      <h2>직원</h2>
      <SearchForm />
    </div>
  );
};

export default Employees;
